'use client';
import { SearchIcon } from '@c/icons';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

export default function SearchBar() {
  const [searchTerm, setSearchTerm] = useState('');
  const router = useRouter();

  const handleSearchBoots = () => {
    if (searchTerm.trim()) {
      router.push(
        `/search?keyword=${encodeURIComponent(
          searchTerm.trim()
        )}&category1=Boots`
      );
    }
  };

  return (
    <div className="relative flex h-auto w-[45rem] items-center justify-between rounded-full bg-white py-2 pl-8 pr-2 sm:w-[73rem]">
      <input
        type="text"
        name="search"
        id="search"
        placeholder="Search all boots"
        className="h-8 w-full rounded-full border-none px-4 py-2 text-[1.8rem] ring-0"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyDown={(ev) => {
          if (ev.key === 'Enter') {
            ev.preventDefault();
            handleSearchBoots();
          }
        }}
      />

      <button
        type="button"
        onClick={handleSearchBoots}
        aria-label="Search"
        className="h-[5rem] w-[5.3rem] items-center justify-center rounded-full bg-brand-secondary p-5"
      >
        <SearchIcon className="h-full w-full text-white" />
      </button>
    </div>
  );
}
